import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lb-button-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lb-button-grid.component.html',
  styleUrls: ['./lb-button-grid.component.scss']
})
export class LbButtonGridComponent {
  @Input() initialButton?: { name: string; clickFunction: () => void };
  @Input() buttonList: { name: string; clickFunction: () => void }[] = [];
  @Input() backgroundImage: string = '';
}
